import React from "react"
import PropTypes from "prop-types"
import SearchInput from "../../components/Listing/SearchInput"
import FilterDropdown from "../../components/Listing/FilterDropdown"
import CustomButton from "../../components/OnboardingComponents/CustomButton"
import { ICONS } from "../../constants/icons"
import { CITY_HUB_FILTER_OPTIONS } from "./cityHubTabs"

/**
 * Second-row City Hub toolbar (Figma title-row):
 * left = page title + subtitle, right = search / filter / primary CTA.
 */
const CityHubTabHeader = ({
  title,
  subtitle,
  search,
  onSearchChange,
  searchPlaceholder = "Search by Title...",
  filters = [],
  onFiltersChange,
  filterConfig,
  showFilter = true,
  ctaLabel,
  ctaIconSrc,
  ctaHideIcon = false,
  ctaLoading = false,
  ctaDisabled = false,
  onCtaClick,
}) => (
  <div className="city-hub__title-row">
    <div className="city-hub__title-left">
      <h2 className="city-hub__page-title">{title}</h2>
      {subtitle ? <p className="city-hub__page-subtitle">{subtitle}</p> : null}
    </div>

    <div className="city-hub__title-actions">
      <SearchInput
        value={search}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
        iconSrc={ICONS.search}
      />
      {showFilter ? (
        <FilterDropdown
          options={filterConfig ? undefined : CITY_HUB_FILTER_OPTIONS}
          selected={filterConfig ? undefined : filters}
          onChange={filterConfig ? undefined : onFiltersChange}
          filters={filterConfig}
        />
      ) : null}
      {ctaLabel ? (
        <CustomButton
          variant="primary"
          size="md"
          type="button"
          trailingIconSrc={
            ctaHideIcon ? undefined : ctaIconSrc || ICONS.plus
          }
          trailingIconAlt=""
          loading={ctaLoading}
          disabled={ctaDisabled}
          onClick={onCtaClick}
        >
          {ctaLabel}
        </CustomButton>
      ) : null}
    </div>
  </div>
)

CityHubTabHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  search: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  searchPlaceholder: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.string),
  onFiltersChange: PropTypes.func,
  filterConfig: PropTypes.arrayOf(PropTypes.object),
  showFilter: PropTypes.bool,
  ctaLabel: PropTypes.string,
  ctaIconSrc: PropTypes.string,
  ctaHideIcon: PropTypes.bool,
  ctaLoading: PropTypes.bool,
  ctaDisabled: PropTypes.bool,
  onCtaClick: PropTypes.func,
}

export default CityHubTabHeader
